<template>
  <div class="gk-image-gallery">
    <LoadingSpinner v-if="loading" :display-text="$gettext('Loading images')" />
    <portal to="imgviewer-modal">
      <ModalBase :show-modal="showZoom" modal-modal widthMd @close-modal="showZoom = false" class="image-viewer--modal">
        <template v-slot:maincontent>
          <img class="image-viewer--modal__img" :src="openImageSrc" @click="showZoom = false">
        </template>
      </ModalBase>
    </portal>
    <div v-if="!loading">
      <ul v-if="images.length > 0" class="image-list">
        <li v-for="(image, index) in images" :key="index">
          <GekkoButton
            v-if="clickAction != 'edit' && editable"
            @click="editImage(image.image)"
            :icon="'fa-solid fa-pencil'"
            class="btn-edit"
          />
          <img :src="image.image" :alt="image.name" @click="imgClickHandler(image)">
        </li>
      </ul>
      <div v-else>
        {{ $gettext('Your gallery is empty') }}
      </div>
    </div>
  </div>
</template>

<script>
import GekkoButton from "@/components/GekkoButton";
import ModalBase from "@/components/base_components/ModalBase";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

import AiAssistantService from '@/store/services/ai.assistant.service.js'

export default {
  name: 'ImageGallery',
  components: {
    GekkoButton,
    ModalBase,
    LoadingSpinner
  },
  props: {
    clickAction: {
      type: String,
      default: 'open'
    },
    editable: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      loading: false,
      showZoom: false,
      openImageSrc: null,
      images: []
    }
  },
  created () {
    this.setupData()
  },
  methods: {
    setupData () {
      this.loading = true
      AiAssistantService.getLogos().then((response) => {
        this.images = response.data
        this.loading = false
      })
    },
    imgClickHandler (image) {
      if (this.clickAction === 'open') {
        this.openImageSrc = image.image
        this.showZoom = true
      }
      if (this.clickAction === 'select') {
        this.$emit('selected-img', image)
      }
      if (this.clickAction === 'edit') {
        this.editImage(image.image)
      }
    },
    editImage (img_src) {
      this.$emit('edit-img', img_src)
    }
  }
}
</script>

<style lang="scss" scoped>
  .gk-image-gallery {
    $listGap: 0.5rem;
    position: relative;
    height: var(--wiz-component-available-height);
    .image-list {
      display: flex;
      flex-wrap: wrap;
      gap: $listGap;
      list-style: none;
      padding: 3px;
      li {
        flex: 0 0 100%;
        aspect-ratio: 1;
        border-radius: 12px;
        overflow: hidden;
        border: 2px solid $colorBorderDash;
        outline: 3px solid transparent;
        transition: outline 0.2s ease;
        cursor: pointer;
        position: relative;
        &:hover {
          outline: 3px solid $colorBrand;
        }
        .btn-edit {
          position: absolute;
          top: 0.25rem;
          right: 0.25rem;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 32px;
          width: 32px;
          background: #00000066;
          color: white;
          border: none;
          &:hover {
            background: #000000b3;
          }
        }
        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
        &:last-child {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          font-size: 50px;
          background: #F4F4F4;
          color: $colorBlue;
          &:hover {
            outline: 3px solid $colorBlue;
          }
          span { 
            font-size: 1rem;
            color: $colorBlue;
          }
        }
      }
    }
    @media (min-width: 576px) {
      .image-list {
        li {
          flex: 0 0 calc(50% - #{$listGap});
        }
      }
    }
    @media (min-width: 768px) {
      .image-list {
        li {
          flex: 0 0 calc(33.333% - #{$listGap});
        }
      }
    }
  }
</style>